import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { MessageService } from '../services/message.service';
import { Message } from '../models/message.model';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService, private messageService: MessageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Start the loading state
    this.loadingService.start();
      
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err instanceof HttpErrorResponse) {
          if(err.status==298){
            // Show specific error message from Update Organization Iflow
            let message:Message;
            message = {
              text: err.error.text,
              placement: 'BottomCenter',
              duration: 5000,
              design: 'Error',
            };            
            this.messageService.show(message);
          }else{
            // Show standard error message
            this.messageService.show();
          }          
        }
        return throwError(err);
      }),
      finalize(() => this.loadingService.end())
    );
  }
}
